import moment from 'moment'
import { DATE_FORMAT_SAVE, DATE_FORMAT_VIEW, DATE_TIME_FORMAT_VIEW } from '../constants'
import 'moment-duration-format'

export const dateFormat = (value, format = DATE_FORMAT_VIEW) => {
	return moment(value).format(format)
}

export const datetimeFormat = (value, format = DATE_TIME_FORMAT_VIEW) => {
	return moment(value).format(format)
}

export const toDate = (value, format = DATE_FORMAT_SAVE) => {
	return moment(value, format).toDate()
}

export function calculateDuration(startTime, endTime) {
	if (!!startTime && !!endTime) {
		const startMoment = moment(startTime)
		const endMoment = moment(endTime)
		const duration = moment.duration(endMoment.diff(startMoment))
		let formattedDuration = ''

		const hours = Math.floor(duration.asHours())
		const minutes = Math.floor(duration.asMinutes()) % 60

		if (hours > 0) {
			formattedDuration += `${hours} hour`
			if (hours > 1) {
				formattedDuration += 's'
			}
		}

		if (minutes > 0) {
			if (formattedDuration.length > 0) {
				formattedDuration += ' '
			}
			formattedDuration += `${minutes} minute`
			if (minutes > 1) {
				formattedDuration += 's'
			}
		}

		if (formattedDuration.length === 0) {
			formattedDuration = '0 seconds'
		}

		return formattedDuration
	} else {
		return 'Invalid time'
	}
}

export function convertToFormattedString(startTime) {
	if (!!startTime) {
		const startMoment = moment(startTime)

		const startDateString = startMoment.format('dddd MMM D, YYYY')
		const startTimeString = startMoment.format('h:mmA')

		return `${startDateString} ${startTimeString}`
	} else {
		return 'Invalid time'
	}
}

export function convertToFormatteDate(startDate) {
	if (!!startDate) {
		const startMoment = moment(startDate)

		return {
			day: startMoment.format('dddd'),
			month: startMoment.format('MMM'),
			numberDay: startMoment.format('D'),
			year: startMoment.format('YYYY'),
		}
	} else {
		return 'Invalid time'
	}
}

export function replaceDateInTimestamp(originalDate, newDate) {
	// Create a new Date object from the original date string
	if (!!originalDate && !!newDate) {
		const dateObj = new Date(originalDate.toString())

		// Create a new Date object from the desired date
		const desiredDate = new Date(newDate)

		// Update the year, month, and day of the date object
		dateObj.setFullYear(desiredDate.getFullYear())
		dateObj.setMonth(desiredDate.getMonth())
		dateObj.setDate(desiredDate.getDate())
		return dateObj
	}
}

export function calculateInterviewDuration(interviewStartTime, interviewEndTime) {
	const startTime = moment(interviewStartTime)
	const endTime = moment(interviewEndTime)

	return endTime.isBefore(startTime)
}
